import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PAGE_NAME_MAP = {
  "/": "Home",
  "/committees": "Committees",
  "/committees/consulting": "Consulting",
  "/committees/policy": "Policy & Research",
  "/committees/expansion": "Expansion",
  "/committees/outreach": "Outreach",
  "/newsletter": "Marketing",
  "/conference": "Case Competition",
  "/team": "Team",
  "/contact": "Contact",
  "/member-resources/professional-development": "Professional Development",
  "/member-resources/general-info": "General Member Info",
  "/member-resources/philanthropy": "Philanthropy",
};

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    const pageName = PAGE_NAME_MAP[location.pathname] || location.pathname;
    axios.post(`${API}/analytics/pageview`, {
      page: pageName,
      path: location.pathname,
      referrer: document.referrer || "",
    }).catch(() => {});
  }, [location.pathname]);

  // Global external link click tracker
  useEffect(() => {
    function handleClick(e) {
      const anchor = e.target.closest("a[href]");
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href || href.startsWith("/") || href.startsWith("#")) return;
      try {
        const url = new URL(href, window.location.origin);
        if (url.origin === window.location.origin) return;
        const pageName = PAGE_NAME_MAP[location.pathname] || location.pathname;
        const label = anchor.textContent?.trim().slice(0, 100) || anchor.getAttribute("aria-label") || "";
        axios.post(`${API}/analytics/click`, {
          url: href,
          label,
          page: pageName,
        }).catch(() => {});
      } catch {
        // invalid URL, skip
      }
    }
    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, [location.pathname]);
}
